import { Injectable, Input, Component } from '@angular/core';
import { Observable, } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'confirm-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Confirmation</h4>
    </div>
    <div class="modal-body">
      {{message}}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="confirm()" >Ok</button>
      <button type="button" class="btn btn-light" (click)="cancel()">Annuler</button>
    </div>
  `
})
export class ConfirmModalComponent{

  @Input() message: string;

  constructor(
    private _activeModal: NgbActiveModal
  ) { 
  }

  confirm(){
    this._activeModal.close(true);
  }

  cancel(){
    this._activeModal.dismiss(false);
  }

}

@Component({
  selector: 'alert-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Information</h4>
    </div>
    <div class="modal-body">
      {{message}}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="confirm()">Ok</button>
    </div>
  `
})
export class AlertModalComponent{

  @Input() message: string;

  constructor(
    private _activeModal: NgbActiveModal
  ) { 
  }

  confirm(){
    this._activeModal.close(true);
    this._activeModal.dismiss(true);
  }
}


@Injectable()
export class ConfirmationGuardService {

  constructor(private _modalService: NgbModal) { }

  /**
  * Create a confirmation guard message with window.confirm
  * @param message - confirmation message
  */
  confirm(message?: string): any{
    const modalRef = this._modalService.open(ConfirmModalComponent, {size: 'lg'});
    modalRef.componentInstance.message = message || 'Are you sure?';
    return modalRef.result;
  };
  /**
  * Create an alert message with window.alert
  * @param message - alert message
  */
  alert(message?: string): any {
    const modalRef = this._modalService.open(AlertModalComponent, {size: 'lg'});
    modalRef.componentInstance.message = message || 'Are you sure?';
    return modalRef.result;
  };
}
